import styled from "styled-components";

import { SquareGridItem } from "icons/SquareGrid/styles";

import colors from "core/colors";

export const AssetContainer = styled.div`
    width: 100%;
    background-color: ${colors.primary.diamond};

    & > * {
        /* center absolutely positioned asset */
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        /* resize asset so longest side spans parent container */
        max-height: 100%;
        max-width: 100%;
    }
`;

export const ContentContainer = styled.div`
    ${AssetContainer} {
        margin-bottom: 8px;

        /* give asset container 1:1 aspect ratio */
        position: relative;
        &:after {
            content: "";
            display: block;
            padding-bottom: 100%;
        }
    }
`;

export const UploadsGridContainer = styled.div`
    ${SquareGridItem} {
        /* extend height of SquareGridItem */
        &:after {
            padding-bottom: 120%;
        }
    }
`;
